import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MODALS, PERMISSIONS } from '../../../constants';
import { checkPermisson, getTennisCompetitions } from '../../../selectors/common';
import { getTennisLiveTemplate } from '../../../selectors/teams';
import PlayersTemplate from '..';
import { aGetTennisLiveTemplateRequest } from '../../../reducers';
import { aSetOpenModal } from '../../../reducers/common';

const mapToProps = (state) => ({
  tennisLiveTemplate: getTennisLiveTemplate(state),
  competitions: getTennisCompetitions(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getTennisLiveTemplateRequest: (payload) => dispatch(aGetTennisLiveTemplateRequest(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
});
class TennisLiveTemplate extends Component {
  constructor(props) {
    super(props);

    this.hasPermissionTo = {
      add: props.checkPermisson(PERMISSIONS.TENNIS_LIVE_TEMPLATES_APPLY),
      view: props.checkPermisson(PERMISSIONS.TENNIS_LIVE_TEMPLATE_VIEW),
    };
  }

  componentDidMount() {
    this.props.getTennisLiveTemplateRequest();
  }

  render() {
    return (
      <PlayersTemplate
        hasPermissionToAdd={this.hasPermissionTo.add}
        hasPermissionToView={this.hasPermissionTo.view}
        leagues={this.props.competitions}
        addModalName={MODALS.TENNIS_LIVE_TEMPLATE_ADD}
        playersTemplate={this.props.tennisLiveTemplate}
        addBtnLabel="New Live Template"
      />
    );
  }
}

export default connect(mapToProps, actionsToProps)(TennisLiveTemplate);
